import { render, staticRenderFns } from "./PiperunIcon.vue?vue&type=template&id=a32afe4a&"
import script from "./PiperunIcon.vue?vue&type=script&lang=ts&"
export * from "./PiperunIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports